/**
 * Global JavaScript for Terminal Shopify Theme
 * Handles common functionality and utilities
 */

// Global utilities
window.TerminalUtils = {
  // Format currency
  formatCurrency: function(amount, currency = 'USD') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  },

  // Debounce function
  debounce: function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  // Throttle function
  throttle: function(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  },

  // Generate unique ID
  generateId: function() {
    return Math.random().toString(36).substr(2, 9);
  },

  // Check if element is in viewport
  isInViewport: function(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
};

// Global error handling
window.addEventListener('error', function(e) {
  console.error('Terminal Theme Error:', e.error);
  
  // Show user-friendly error message
  if (window.terminalStore) {
    window.terminalStore.addOutput('An error occurred. Please refresh the page.', 'error');
  }
});

// Global unhandled promise rejection handling
window.addEventListener('unhandledrejection', function(e) {
  console.error('Terminal Theme Promise Rejection:', e.reason);
  
  // Show user-friendly error message
  if (window.terminalStore) {
    window.terminalStore.addOutput('An error occurred. Please try again.', 'error');
  }
});

// Initialize theme when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Add loading class to body
  document.body.classList.add('theme-loaded');
  
  // Initialize any global components
  initializeGlobalComponents();
});

function initializeGlobalComponents() {
  // Initialize keyboard shortcuts
  initializeKeyboardShortcuts();
  
  // Initialize accessibility features
  initializeAccessibility();
  
  // Initialize performance monitoring
  initializePerformanceMonitoring();
}

function initializeKeyboardShortcuts() {
  document.addEventListener('keydown', function(e) {
    // Ctrl/Cmd + K to focus terminal input
    if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
      e.preventDefault();
      const input = document.getElementById('terminal-input');
      if (input) {
        input.focus();
      }
    }
    
    // Escape to close modals
    if (e.key === 'Escape') {
      const modal = document.querySelector('.terminal-modal');
      if (modal && window.terminalStore) {
        window.terminalStore.closeModal();
      }
    }
  });
}

function initializeAccessibility() {
  // Add ARIA labels to interactive elements
  const terminalInput = document.getElementById('terminal-input');
  if (terminalInput) {
    terminalInput.setAttribute('aria-label', 'Terminal command input');
    terminalInput.setAttribute('role', 'textbox');
  }
  
  // Add ARIA live region for terminal output
  const terminalOutput = document.getElementById('terminal-output');
  if (terminalOutput) {
    terminalOutput.setAttribute('aria-live', 'polite');
    terminalOutput.setAttribute('role', 'log');
  }
}

function initializePerformanceMonitoring() {
  // Monitor performance and show warnings for slow operations
  const observer = new PerformanceObserver(function(list) {
    list.getEntries().forEach(function(entry) {
      if (entry.duration > 1000) {
        console.warn('Slow operation detected:', entry.name, entry.duration + 'ms');
      }
    });
  });
  
  try {
    observer.observe({ entryTypes: ['measure', 'navigation'] });
  } catch (e) {
    // Performance Observer not supported
  }
}

// Export for use in other scripts
window.TerminalTheme = {
  utils: window.TerminalUtils,
  version: '1.0.0'
};
